export default "__VITE_ASSET__zg69_HJS__"